import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import Mixins from './mixins';

const parent = _.clone(VueFormGenerator.component.components.formGroup.components.fieldInput);

Vue.component('fieldHidden', _.merge({}, parent, {
  mixins: Mixins,
}));




// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/vue-form-generator/fields/fieldHidden.js